const DefaultToFalse = function () {
  return false
}

export default DefaultToFalse
